var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43357 5.11367L7.4424 5.12251L7.45124 5.11367L12.5238 0.0411152L14.0526 1.56995L7.4424 8.18018L0.832174 1.56995L2.36101 0.041115L7.43357 5.11367Z",
    fill: "#FF9D59",
    stroke: "#1E440B",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowOrange);
export default __webpack_public_path__ + "static/media/down_arrow_orange.e4536ced58a587257f7dd05099bb87db.svg";
export { ForwardRef as ReactComponent };